import React from 'react';

import { CompetitorBatchConfig } from '../types';

/**
 * Schedules competitor batches to be revealed based on their delayMs.
 * Returns an array of batch indices that have been revealed.
 */
export function useBatchReveal(
  batches: CompetitorBatchConfig[],
  active: boolean,
): number[] {
  const [revealedBatches, setRevealedBatches] = React.useState<number[]>([]);
  const timersRef = React.useRef<ReturnType<typeof setTimeout>[]>([]);

  React.useEffect(() => {
    if (!active) return;

    setRevealedBatches([]);
    timersRef.current = [];

    batches.forEach((batch, index) => {
      const timer = setTimeout(() => {
        setRevealedBatches((prev) => [...prev, index]);
      }, batch.delayMs);
      timersRef.current.push(timer);
    });

    return () => {
      timersRef.current.forEach(clearTimeout);
      timersRef.current = [];
    };
  }, [batches, active]);

  return revealedBatches;
}
